<div aria-busy="true" aria-live="polite" class="overlay" role="status">
  <div class="overlay__content">
    <img
      alt="Loading"
      class="overlay__icon"
      fetchpriority="high"
      loading="eager"
      role="img"
      src="assets/images/loading-icon.png"
    />
    <p class="overlay__message">{{ message() }}</p>
  </div>
</div>
